import { render } from "./EditItemModal.vue?vue&type=template&id=6ab5e5f2&ts=true"
import script from "./EditItemModal.vue?vue&type=script&lang=ts"
export * from "./EditItemModal.vue?vue&type=script&lang=ts"

import "./EditItemModal.vue?vue&type=style&index=0&id=6ab5e5f2&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__